import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../api';
import {
    Button,
    Input,
    Container,
    Row,
    Col,
    FormGroup,
} from "reactstrap";
import AlertMessage from './AlertMessage';
import Cookies from 'js-cookie';

const Editstock4 = () => {
    const { id } = useParams();
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");

    console.log('id',id);
    const [updateValue, setupdateValues] = useState({
        product_id: id,
        product_name: '',
        available_stock: '',
        total_stock: '',
        cost: ''
    });

    console.log('update2',updateValue);

    

    useEffect(() => {
        console.log("Item ID:", id); 
        const company_id = Cookies.get('company_id');
        api.get(`ViewStockSTM.php?id=${id}&company_id=${company_id}`) 
            .then((res) => {
                const { product } = res.data; 
                if (product) {
                    setupdateValues(prevState => ({
                        ...prevState,
                        product_name: product.product_name,
                        available_stock: product.available_stock,
                        total_stock: product.total_stock,
                        cost: product.cost,
                    }));
                } else {
                    setAlertMsg("Product not found or data is missing.");
                    setAlertVisible(true);
                }
            })
            .catch((err) => {
                setAlertMsg("Error fetching product data.");
                setAlertVisible(true);
                console.log(err);
            });
    }, [id]);
    

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { product_name, available_stock, total_stock, cost } = updateValue;
        if (
            !product_name &&
            !available_stock &&
            !total_stock &&
            !cost
        ) {
            setAlertMsg("Please fill at least one field before submitting.");
            setAlertVisible(true);
            return;
        }

        try {
            const company_id = Cookies.get('company_id');
            const dataToSend = { ...updateValue, company_id };
            const response = await api.post(`edititemsSTM.php?company_id=${company_id}`, dataToSend);
            console.log("Data sent successfully:", response.data);
    
            // Check if the status is 'success' and then navigate back
            if (response.data.status === 'success') {
                window.history.back(); // Navigate back
            } else {
                // Optionally, you can handle other cases like showing an error message
                console.log("Update was not successful:", response.data.message);
            }
        } catch (error) {
            console.error("Error submitting data:", error);
        }
    };
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setupdateValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    console.log('update',updateValue);

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 60 }}>
                <AlertMessage
                    visible={alertVisible}
                    message={alertMsg}
                    toggle={() => setAlertVisible(false)}
                />
            </div>
                <Col className="order-xl-2 mb-5 mb-xl-0 text-center  mb-5">
                    <h1>Edit Material Details</h1>
                </Col>
                <Link to="/store-admin/store-management/Storemanagement4"> <Button className='ml-5' style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}>Back</Button></Link>
                <Container className="py-4 ">
                    <div className="p-4 rounded" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
                        <Row className='px-3'>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-status">Item Name</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-name"
                                        type="text"
                                        name="product_name"
                                        onChange={handleInputChange}
                                        value={updateValue.product_name}
                                    />
                                </FormGroup>
                            </Col>
                            
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-manager">Current Stock</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-manager"
                                        type="number"
                                        name='available_stock'
                                        onChange={handleInputChange}
                                        value={updateValue.available_stock}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-starting">Total Stock</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-starting"
                                        type="text"
                                        name="total_stock"
                                        onChange={handleInputChange}
                                        value={updateValue.total_stock}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-ending">Cost</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-ending"
                                        type="number"
                                        name="cost"
                                        onChange={handleInputChange}
                                        value={updateValue.cost}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' className='text-center mb-2'>
                                <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit" onClick={handleSubmit}>Submit</Button>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Editstock4;
